function ErrorView({ goBack }: Readonly<{ goBack?: () => void }>) {
  return (
    <html>
      <body>
        <header className="bmrzLJ"></header>

        <main className="kjROlt">
          <div className="loIQBs">
            <div className="iBjvEf">
              <div className="eWTGZe">
                <div className="brPxdw">
                  <div className="cTvjmP">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                      <defs>
                        <radialGradient
                          id="gradient"
                          cx="509.5"
                          cy="440"
                          r="453.22"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stopColor="#d9d9d9"></stop>
                          <stop offset="1" stopColor="#d9d9d9" stopOpacity="0"></stop>
                        </radialGradient>
                      </defs>
                      <path
                        d="M1000.5 62v-4h-49V28h-4v30h-76V28h-4v30h-76V28h-4v30h-76V28h-4v30h-76V28h-4v30h-76V28h-4v30h-76V28h-4v30h-76V28h-4v30h-76V28h-4v30h-76V28h-4v30h-76V28h-4v30h-76V28h-4v30h-49v4h49v76h-49v4h49v76h-49v4h49v76h-49v4h49v76h-49v4h49v76h-49v4h49v76h-49v4h49v76h-49v4h49v76h-49v4h49v76h-49v4h49v70h4v-70h76v70h4v-70h76v70h4v-70h76v70h4v-70h76v70h4v-70h76v70h4v-70h76v70h4v-70h76v70h4v-70h76v70h4v-70h76v70h4v-70h76v70h4v-70h76v70h4v-70h49v-4h-49v-76h49v-4h-49v-76h49v-4h-49v-76h49v-4h-49v-76h49v-4h-49v-76h49v-4h-49v-76h49v-4h-49v-76h49v-4h-49v-76h49v-4h-49V62Zm-853 716h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76V62h76Zm80 640h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76V62h76Zm80 640h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76V62h76Zm80 640h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76V62h76Zm80 640h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76V62h76Zm80 640h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76V62h76Zm80 640h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76V62h76Zm80 640h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76V62h76Zm80 640h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76V62h76Zm80 640h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76V62h76Zm80 640h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76v-76h76Zm0-80h-76V62h76Z"
                        id="Ebene_2"
                        data-name="Ebene 2"
                        style={{ fill: 'url(#gradient)' }}
                      ></path>
                      <g id="Ebene_1" data-name="Ebene 1">
                        <path className="cls-2" d="M638.08 248.46h330.08"></path>
                        <path
                          d="M702.26 237h213.18v251H702.26z"
                          style={{
                            fill: 'rgb(227, 227, 227)',
                            strokeMiterlimit: 10,
                            strokeWidth: 4,
                            stroke: 'rgb(61, 61, 61)',
                          }}
                        ></path>
                        <path className="cls-4" d="M702.26 237H897.1v234.95H702.26z"></path>
                        <path
                          className="cls-5"
                          d="M702.26 237h213.18v251H702.26zM915.44 466.22H702.26M842.09 410.06H702.26M886.79 410.06h-28.66"
                        ></path>
                        <path
                          className="cls-6"
                          d="M636.93 241.58h32.09v12.61h-32.09zM954.41 241.58h32.09v12.61h-32.09z"
                        ></path>
                        <text
                          transform="rotate(11.07 -3416.629 1505.884)"
                          style={{
                            letterSpacing: '-0.02em',
                            fontSize: '392.52px',
                            fontFamily: 'AktivGrotesk',
                            fontWeight: 700,
                            fill: 'rgb(61, 61, 61)',
                          }}
                        >
                          5
                        </text>
                        <text
                          transform="rotate(-2.47 17094.61 -10423.354)"
                          style={{
                            letterSpacing: '-0.09em',
                            fontSize: '392.52px',
                            fontFamily: 'AktivGrotesk',
                            fontWeight: 700,
                            fill: 'rgb(61, 61, 61)',
                          }}
                        >
                          0
                        </text>
                        <text
                          transform="rotate(8.1 -4977.588 5498.353)"
                          style={{
                            letterSpacing: '0.13em',
                            fontSize: '392.52px',
                            fontFamily: 'AktivGrotesk',
                            fontWeight: 700,
                            fill: 'rgb(61, 61, 61)',
                          }}
                        >
                          0
                        </text>
                        <ellipse className="cls-10" cx="122" cy="702" rx="45.5" ry="53"></ellipse>
                        <ellipse
                          className="cls-10"
                          cx="134"
                          cy="669"
                          rx="53"
                          ry="45.5"
                          transform="matrix(.5 -.87 .87 .5 -512.37 450.55)"
                        ></ellipse>
                        <ellipse
                          className="cls-10"
                          cx="155.27"
                          cy="658.36"
                          rx="62.65"
                          ry="38.06"
                          transform="rotate(-60 155.273 658.36)"
                        ></ellipse>
                        <ellipse
                          className="cls-10"
                          cx="99.01"
                          cy="624.36"
                          rx="45.5"
                          ry="61.21"
                          transform="matrix(.93 -.36 .36 .93 -220.76 79.04)"
                        ></ellipse>
                        <ellipse
                          className="cls-10"
                          cx="122.27"
                          cy="547.21"
                          rx="104.39"
                          ry="47.31"
                          transform="rotate(-87.69 122.29 547.226)"
                        ></ellipse>
                        <circle className="cls-11" cx="468.63" cy="664.47" r="35.41"></circle>
                        <circle className="cls-11" cx="542.24" cy="659.76" r="61.51"></circle>
                        <circle className="cls-11" cx="647.74" cy="657.9" r="82.01"></circle>
                        <circle className="cls-11" cx="737.12" cy="652.45" r="37.28"></circle>
                        <circle className="cls-11" cx="802.27" cy="649.56" r="48.46"></circle>
                        <circle className="cls-11" cx="866.82" cy="658.08" r="35.41"></circle>
                        <path className="cls-2" d="M58.5 854h956M.5 854h41"></path>
                        <path
                          d="M277.5 649.1h595a50 50 0 0 1 50 50v177h-695v-177a50 50 0 0 1 50-50Z"
                          transform="rotate(180 575 762.615)"
                          style={{
                            fill: 'rgb(252, 252, 252)',
                            strokeMiterlimit: 10,
                            strokeWidth: 4,
                            stroke: 'rgb(61, 61, 61)',
                          }}
                        ></path>
                        <path
                          d="M647.24 649.1H872.5a50 50 0 0 1 50 50v177H597.24v-177a50 50 0 0 1 50-50Z"
                          transform="rotate(180 759.87 762.615)"
                          style={{
                            fill: 'rgb(217, 217, 217)',
                            strokeMiterlimit: 10,
                            strokeWidth: 4,
                            stroke: 'rgb(61, 61, 61)',
                          }}
                        ></path>
                        <path
                          d="M305.49 649.1h539a40 40 0 0 1 40 40v187h-619v-187a40 40 0 0 1 40-40Z"
                          transform="rotate(180 575 762.615)"
                          style={{ fill: 'rgb(247, 247, 247)' }}
                        ></path>
                        <path
                          d="M646.51 649.1h198a40 40 0 0 1 40 40v187h-278v-187a40 40 0 0 1 40-40Z"
                          transform="rotate(180 745.505 762.615)"
                          style={{ fill: 'rgb(227, 227, 227)' }}
                        ></path>
                        <path
                          className="cls-4"
                          d="M316.07 649.1h517.86a20 20 0 0 1 20 20v207H296.07v-207a20 20 0 0 1 20-20Z"
                          transform="rotate(180 575 762.615)"
                        ></path>
                        <path
                          className="cls-5"
                          d="M277.5 649.1h595a50 50 0 0 1 50 50v177h-695v-177a50 50 0 0 1 50-50Z"
                          transform="rotate(180 575 762.615)"
                        ></path>
                        <path
                          className="cls-5"
                          d="M448.97 662.07H922.5M227.5 662.07h83.4M325.73 662.07h83.4"
                        ></path>
                        <path
                          className="cls-16"
                          d="M117.5 785V497M116.96 696.02 152.5 663M118 641.5c0-2-31.5-56.5-31.5-56.5"
                        ></path>
                        <path
                          className="cls-11"
                          d="M845.39 908.15a16.76 16.76 0 0 0-28.61 0ZM797.76 908.15c-4.11-12.36-16.26-21.32-30.62-21.32-.67 0-1.33 0-2 .07a48.46 48.46 0 0 0-84.52-11.45 37.27 37.27 0 0 0-52.1 32.7Z"
                        ></path>
                        <path
                          className="cls-5"
                          d="M610.21 910h247.42M575 910h29.65M561.1 910h8.34M865.05 910h8.34"
                        ></path>
                        <rect
                          className="cls-11"
                          x="690.83"
                          y="635.2"
                          width="27.8"
                          height="149.19"
                          rx="12"
                        ></rect>
                        <rect
                          className="cls-11"
                          x="662.11"
                          y="635.2"
                          width="22.24"
                          height="94.52"
                          rx="11.12"
                        ></rect>
                        <path
                          d="M74.5 786h84v96h-84z"
                          style={{
                            fill: 'rgb(230, 230, 230)',
                            strokeMiterlimit: 10,
                            strokeWidth: 4,
                            stroke: 'rgb(61, 61, 61)',
                          }}
                        ></path>
                        <path className="cls-5" d="M91.5 799h67"></path>
                      </g>
                    </svg>
                  </div>
                </div>
                <div className="gyWQfZ">
                  <div className="ebuPNI">
                    <h1 className="iVufAh">
                      INTERNAL SERVER<span className="jHRhUG">ERROR</span>
                    </h1>
                  </div>
                  <div className="fnnyPD">
                    <p className="eQJbxf">
                      Services aren&apos;t all on track, so the site is temporarily unavailable. We
                      are working on it and will be back shortly.
                    </p>
                  </div>
                  <div className="fgGVqr"></div>
                  <div className="fhglIl">
                    {goBack && (
                      <button onClick={goBack} id="back-button" className="farbKz" type="button">
                        Go back
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

        <div>
          <footer className="flxWwF">
            <hr className="cuWIgZ" />
            <div className="kjROlt">
              <div className="loIQBs">
                <div className="iBjvEf">
                  <div className="cphEXD">
                    <div className="bKChHi"></div>
                    <div className="bKChHi">
                      <div className="eQJbxf iclRGb copyright">
                        © {new Date().getFullYear()} Geberit Sales Ltd
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </body>
    </html>
  );
}

export default ErrorView;
